<div class="row">
  <div class="col-12">
    <fui-heading [text]="'account.storage' | translate" [level]="5"></fui-heading>
  </div>

  <div class="col-12">
    <myp-storage-meter></myp-storage-meter>
    @if (!storageData) {
      <myp-skeleton-loader type="line" height="15px" width="25%"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" height="35px" width="100%" extraContainerClass="m-t-15" borderRadius="30px"></myp-skeleton-loader>
    }
  </div>
  <div class="col-12 m-t-50">
    <fui-heading [text]="'account.workspace_files' | translate" [level]="5"></fui-heading>
  </div>
  @if (!storageData) {
    <div class="col-12">
      <myp-skeleton-loader type="line" height="15px" width="80%" extraContainerClass="m-b-30"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" height="15px" width="80%"></myp-skeleton-loader>
    </div>
  }
  @if (storageData) {
    <div class="col-4 col-lg-3">{{ "account.number_of_files" | translate }}</div>
    <div class="col-8 col-lg-9">
      {{ storageData.count_by_section.files }}
    </div>
    <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
    <div class="col-4 col-lg-3">{{ "account.total_filesize" | translate }}</div>
    <div class="col-8 col-lg-9">
      {{ storageData.total_size_by_section.files | bytesToSize }}
    </div>
    <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
  }

  <div class="col-12 m-t-50">
    <fui-heading [text]="'account.backups' | translate" [level]="5"></fui-heading>
  </div>
  @if (!storageData) {
    <div class="col-12">
      <myp-skeleton-loader type="line" height="15px" width="80%" extraContainerClass="m-b-30"></myp-skeleton-loader>
      <myp-skeleton-loader type="line" height="15px" width="80%"></myp-skeleton-loader>
    </div>
  }
  @if (storageData) {
    <div class="col-4 col-lg-3">{{ "account.number_of_files" | translate }}</div>
    <div class="col-8 col-lg-9">
      {{ storageData.count_by_section.backups }}
    </div>
    <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
    <div class="col-4 col-lg-3">{{ "account.total_filesize" | translate }}</div>
    <div class="col-8 col-lg-9">
      {{ storageData.total_size_by_section.backups | bytesToSize }}
    </div>
    <div class="col-8 col-lg-9 offset-4 offset-lg-3"><hr class="m-y-10" /></div>
    <div class="col-8 col-lg-9 offset-4 offset-lg-3">
      <button class="btn btn-secondary btn-sm" (click)="shouldShowBackups = !shouldShowBackups">
        {{ shouldShowBackups ? ("account.hide_backups" | translate) : ("account.show_backups" | translate) }}
      </button>
    </div>
  }

  @if (shouldShowBackups) {
    <div class="col-12 m-t-50">
      <fui-heading [text]="'account.manage_backups' | translate" [level]="5"></fui-heading>
      @for (backup of backups; track backup) {
        <myp-list-item [title]="backup.filename" [metadata]="getBackupMetadata(backup)" [showImage]="false" [includeChevron]="false">
          <div class="button-content">
            @if (!removingBackups[backup.id]) {
              <fa-icon
                icon="times"
                class="action circle-icon-btn"
                ngbTooltip="{{ 'account.remove_backup' | translate }}"
                tabindex="0"
                (keyup.enter)="removeBackup(backup)"
                (click)="removeBackup(backup)"
              ></fa-icon>
            }
            @if (removingBackups[backup.id]) {
              <fa-icon icon="spinner" animation="spin" class="action circle-icon-btn"></fa-icon>
            }
          </div>
        </myp-list-item>
      }
    </div>
  }
</div>
